<div
  class="tooltip"
  [attr.data-position]="'above'"
  [attr.data-style]="style()"
  [class.tooltip--visible]="visible()"
  [style.left.px]="left()"
  [style.top.px]="top()"
>
  {{ tooltip() }}
</div>
